/* eslint-disable no-console */

/**
 * The interface for a Settings error
 */
export interface SettingsError {
    // The error message
    readonly message: string;

    // The setting value that triggered the error. This value should be the invalid value.
    readonly value: unknown;

    // The path in the settings object where the value is located. We will display this path to help the admin find the problem.
    readonly path?: readonly string[] | undefined;
}


export class SettingsErrorLogger {
    private settingsName: string;

    private settingsObject: {};

    public constructor (settingsName: string, settingsObject: {}) {
        this.settingsName = settingsName;
        this.settingsObject = settingsObject;
    }

    public logError (error: SettingsError): boolean {
        console.log(`%cInvalid settings in ${this.settingsName}.`, 'color:red; font-weight:bold;');

        console.log('%cConfig:', 'margin-left:20px; font-weight:bold;', this.settingsObject);

        if (error.path !== undefined) {
            console.log('%cInvalid value at:', 'margin-left:20px; font-weight:bold;', `${error.path.map((item) => {
                return `${item}`;
            }).join(' => ')}`);
        }

        console.log('%cInvalid value:', 'margin-left:20px; font-weight:bold;', error.value);

        console.log('%cReason:', 'margin-left:20px; font-weight:bold;', error.message);

        return false;
    }
}
